module.exports = __webpack_public_path__ + "img/pdf.6065a48f.png";